<template>
  <table class="table">
    <tbody>
      <tr
        v-for="(item, index) in data"
        :key="item.name"
      >
        <td>
          <span
            class="point"
            :style="{ color: getNextDiagramColor(index) }"
          >&#9679;</span>{{
            item.name
          }}
        </td>
        <td>{{ item.visits }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import diagramColors from '../mixins/diagramColors'

export default {
  name: 'MetricsTable',
  mixins: [diagramColors],
  props: {
    data: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
@import "./resources/css/_variables.scss";

.table tbody tr {
  td {
    font-weight: bold;
    border-top: none;
    border-bottom: 1px solid $hrColor;

    .point {
      padding-right: 8px;
    }

    &:last-child {
      text-align: right;
    }
  }
}
</style>
